
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/me/trusted-contact",
      function () {
        return require("private-next-pages/me/trusted-contact/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/me/trusted-contact"])
      });
    }
  